import React from 'react'

const Transaction = ({ width, height }) => {
  return (
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 13.5 14.136"
      >
        <path
          d="M2 5.375h12.15M11.45 2l3.375 3.375L11.45 8.75m4.05 3.375H3.35m2.7-3.375-3.375 3.375L6.05 15.5"
          transform="translate(-2 -1.682)"
          style={{ fill: 'none', stroke: '#b1b1b1', strokeWidth: '.9px' }}
        />
      </svg>
    </div>
  )
}

export default Transaction
